export default () => (
  <defs>
    <pattern id="hatch" patternUnits="userSpaceOnUse" width="4" height="4" stroke="#f00">
      <line x1="-1" y1="-4" x2="5" y2="2" strokeWidth="0.5"/>
      <line x1="-1" y1="0" x2="5" y2="6" strokeWidth="0.5"/>
    </pattern>
  </defs>
);
